import { FC } from 'react';
import { useSelector } from 'react-redux';
import { InlineFilter } from 'shared/components/InlineFilter';
import { RangeInput } from 'shared/components/RangeInput';
import { useDebouncedCallback, useFilterChangeCallback } from 'shared/hooks';
import { selectRoomArea } from 'shared/selectors/jsonQuery';

export const RoomAreaContainer: FC = () => {
  const { gte: valueMin = null, lte: valueMax = null } = useSelector(selectRoomArea);

  const onChange = useFilterChangeCallback();

  const handleMinValueChange = useDebouncedCallback((value: number | null) => {
    onChange({ action: 'setRoomAreaMin', arguments: [value] });
  });

  const handleMaxValueChange = useDebouncedCallback((value: number | null) => {
    onChange({ action: 'setRoomAreaMax', arguments: [value] });
  });

  return (
    <InlineFilter width={100} label="Комната" dataTestId="roomArea">
      <RangeInput
        min={1}
        max={9999}
        valueMin={valueMin}
        valueMax={valueMax}
        onChangeMin={handleMinValueChange}
        onChangeMax={handleMaxValueChange}
      />
    </InlineFilter>
  );
};
